export default function Step2({ setStep, step2Result }) {
  return (
    <div className="mb-6">
      <div className="mb-6">
        <p className={"mb-0"}>
          {step2Result == "yes"
            ? "Your Belize company is likely taxable within the jurisdiction."
            : "Your Belize company is likely not taxable within the jurisdiction."}
        </p>
      </div>
      <div className={"mt-4"}>
        <div>
          <button
            onClick={() => setStep(3)}
            className="shadow-bbc block w-full rounded-lg border-[0.5px] border-[#007EFF] px-6 py-4 text-left hover:bg-[#007EFF] hover:text-white"
          >
            See your compliance requirements
          </button>
        </div>
      </div>
    </div>
  );
}
